import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class TahsisIptalNedenAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "TahsisIptalNedenListe";
    super(baseUrl);
  }


  getTahsisIptalNedenListe( kullanimSekliKodu?: number){
    return this.get("", { params: { kullanimSekliKodu: kullanimSekliKodu } })

  }

}
export default new TahsisIptalNedenAPI();
class TahsisIptalNedenRequest {
  public TahsisIptalNedenKodu?: number;

  constructor( kullanimSekliKodu?: number) {
   
        this.TahsisIptalNedenKodu = kullanimSekliKodu;

  }
}
export { TahsisIptalNedenRequest };